import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate} from "react-router-dom";


import { useTranslation } from "react-i18next";
import axios from "axios";

import swal from 'sweetalert';
import ttsAudio from "../assets/sound/tts_01.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/1.mp3";
import ttsAudio_jp from "../assets/sound/jp/1.mp3";
import ttsAudio_cn from "../assets/sound/cn/1.mp3";
import ttsAudio_mn from "../assets/sound/mn/1.mp3";

const Agree = () => {
    const { t,i18n } = useTranslation();
    const navigate = useNavigate();

    const audioRef = useRef(null);

    const LIGHT_API = "http://127.0.0.1:18790";



    const clickNext= () => {
        navigate('/about/');
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    useEffect(() => {
        let cancelled = false;

        const setIdleIfLocalLightExists = async () => {
            try {
                // 1) 로컬 조명 서버 살아있는지 체크
                const healthRes = await axios.get(`${LIGHT_API}/health`, { timeout: 600 });
                if (cancelled) return;
                if (!healthRes?.data?.ok) return;

                // 2) 살아있으면 idle(노랑) 적용
                await axios.post(`${LIGHT_API}/light/idle`, {}, { timeout: 800 });
            } catch (err) {
                // 로컬 서버 없거나 꺼져있으면 조용히 무시
                console.warn("Local light server not reachable. Skip light control.");
            }
        };

        setIdleIfLocalLightExists();

        return () => {
            cancelled = true;
        };
    }, []);


    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            {lng == "ko" && (
                <div className="input-area">
                    <div className="step_area">Privacy policy</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("개인정보 처리방침 안내")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                ㈜오토웰즈는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한
                                고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                            </p>
                            <h4 className="sub_tit">제1조 개인 정보의 처리 목적</h4>
                            <p className="text">(주)오토웰즈는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                            <p className="text">
                                1. 생체 정보
                                <br />
                                개인의 생체 정보(심박수, 호흡수, 재실 감지 값)를 이상 판별 감지 시스템 연구 목적으로 개인정보를 처리합니다.
                            </p>
                            <h4 className="sub_tit">제2조 개인정보의 처리 및 보유 기간</h4>
                            <p className="text">
                                ① ㈜오토웰즈는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
                                <br />② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
                            </p>
                            <p className="sm_text">
                                1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
                                <br />
                                1) 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지
                                <br />
                                <br />
                                2. 재화 또는 서비스 제공 : 재화·서비스 공급완료 및 요금결제·정산 완료시까지 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지
                                <br />
                                1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록
                                <br />
                                - 표시·광고에 관한 기록 : 6개월
                                <br />
                                - 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년 <br />
                                - 소비자 불만 또는 분쟁처리에 관한 기록 : 3년
                                <br />
                                <br />
                                2) 「통신비밀보호법」에 따른 통신사실확인자료 보관
                                <br />
                                - 가입자 전기통신일시, 개시·종료시간, 상대방 가입자번호, 사용도수, 발신기지국 위치추적자료 : 1년 <br />
                                - 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월
                                <br />
                                <br />
                                3) 「생체인식 특징정보」 민감정보인 특징정보는 개인정보 보호법 제23조 민감정보의 처리
                                <br />
                                <br />
                                3. 생체 정보: 회원 탈퇴 시까지 <br />
                                1) 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지
                            </p>
                            <h4 className="sub_tit">제3조 처리하는 개인정보의 항목</h4>
                            <p className="text">㈜오토웰즈는 다음의 개인정보 항목을 처리하고 있습니다.</p>
                            <p className="text">
                                1. 회원 가입 및 관리 - 성명, 생년월일, 주소, 전화번호, 이메일주소
                                <br />
                                2. 재화 또는 서비스 제공 - 성명, 생년월일, 주소, 전화번호, 이메일주소
                                <br />
                                3. 생체 정보 - 개인의 생체 정보(심박수, 호흡수, 재실 감지 값)
                            </p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="20%" />
                                        <col width="20%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>수집목적</th>
                                            <th>수집항목</th>
                                            <th>보유 및 이용기간</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>회원 가입 및 관리</td>
                                            <td>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별‧인증, 회원자격 유지‧관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지‧통지, 고충처리 목적</td>
                                            <td>성명, 생년월일, 주소, 전화번호, 이메일 주소</td>
                                            <td>
                                                회원 탈퇴 시까지 <br />※ 단, 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시 까지
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                재화 또는 <br />
                                                서비스 제공
                                            </td>
                                            <td>물품배송, 서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증의 목적으로 개인정보를 처리합니다.</td>
                                            <td>성명, 생년월일, 주소, 전화번호, 이메일 주소</td>
                                            <td>
                                                재화 · 서비스 공급완료 및 요금결제 · 정산 완료시까지 <br />※ 단, 관계 법령에 따라 파기하지 않고 보존하여야 하는 경우에는 해당 기간까지
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>생체 정보</td>
                                            <td>이상 판별 감지 시스템 연구</td>
                                            <td>심박수, 호흡수, 재실감지 값</td>
                                            <td>
                                                회원 탈퇴 시까지 <br />※ 단, 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시 까지
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h4 className="sub_tit">제4조 개인정보의 제3자 제공에 관한 사항</h4>
                            <p className="text">
                                ① ㈜오토웰즈는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서 만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게
                                제공하지 않습니다. <br />② ㈜오토웰즈는 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다.
                            </p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="40%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>수집목적</th>
                                            <th>수집항목</th>
                                            <th>보유 및 이용기간</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>국가 기관</td>
                                            <td>특정정보 제공</td>
                                            <td>성명, 생년월일, 주소, 전화번호, 이메일 주소, 생체정보 </td>
                                            <td>
                                                회원 탈퇴 시까지 <br />※ 단, 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료시 까지
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p className="text">③ ㈜오토웰즈는 다음과 같이 재난, 감염병, 급박한 생명·신체 위험을 초래하는 사건· 사고, 급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보 주체의 동의 없이 관계기관에 개인 정보를 제공할 수 있습니다.</p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>근거법령</th>
                                            <th>제공 기관</th>
                                            <th>제공되는 개인정보</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>자살위험자 보호</td>
                                            <td>자살예방법</td>
                                            <td>
                                                경찰관서 <br />
                                                소방관서
                                            </td>
                                            <td>• (정보통신서비스 제공자인 경우 기재) 긴급구조대상자의 성명, 주민등록번호(주민등록번호가 없는 경우 생년월 일), 주소, 전화번호, 아이디, 전자우편주소 및 개인위치정보</td>
                                        </tr>
                                        <tr>
                                            <td>긴급 구조요청 등 대응</td>
                                            <td>위치정보법</td>
                                            <td>소방관서</td>
                                            <td>• 개인위치정보</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h4 className="sub_tit">제5조 개인정보의 파기 절차 및 방법에 관한 사항</h4>
                            <p className="text">
                                ① ㈜오토웰즈는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. <br />② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속
                                보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터 베이스(DB)로 옮기거나보관장소를 달리하여 보존합니다.
                                <br />③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
                            </p>
                            <p className="text">
                                1. 파기절차
                                <br />
                                ㈜오토웰즈는 파기 사유가 발생한 개인정보를 선정하고, '개인정보처리자명'의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                                <br />
                                <br />
                                2. 파기방법
                                <br />
                                ㈜오토웰즈는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록· 저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
                            </p>
                            <p className="sub_tit">제6조 정보주체와 법정대리인의 권리‧의무 및 행사방법에 관한 사항</p>
                            <p className="text">
                                ① 정보주체는 ㈜오토웰즈에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
                                <br />
                                ※ 만 14세 미만 아동에 관한 개인정보의 열람등 요구는 법정대리인이 직접 해야 하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다.
                                <br />
                                ② 권리 행사는 ㈜오토웰즈에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, ㈜오토웰즈는 이에 대해 지체없이 조치하겠습니다.
                                <br />
                                ③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                                <br />
                                ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
                                <br />
                                ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
                                <br />⑥ ㈜오토웰즈는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
                            </p>
                            <h4 className="sub_tit">제7조 개인정보의 안전성 확보조치에 관한 사항</h4>
                            <p className="text">
                                1. 관리적 조치 : 내부관리계획 수립·시행, 전담조직 운영, 정기적 직원 교육
                                <br />
                                2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신
                                <br />
                                3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제
                            </p>
                            <h4 className="sub_tit">제8조 개인정보를 자동으로 수집하는 장치의 설치‧운영 및 그 거부에 관한 사항 – 해당시</h4>
                            <p className="text">&lt;개인정보처리자명&gt;은 정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용하지 않습니다.</p>
                            <h4 className="sub_tit">제9조 개인정보 보호책임자에 관한 사항</h4>
                            <p className="text">① ㈜오토웰즈는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정 하고 있습니다.</p>
                            <p className="sm_text">
                                ‣ 개인정보 보호책임자 <br />
                                성명 : 곽건호
                                <br />
                                직책 : 대표이사
                                <br />
                                연락처 : 010-3287-3222
                                <br />
                                전화번호 : 062-372-3731
                                <br />
                                이메일 : andrew.kwak.2025@gmail.com
                                <br />
                                팩스번호 : 062-372-3735
                                <br />※ 개인정보보호 담당부서로 연결됩니다.
                            </p>
                            <h4 className="sub_tit">제10조 개인정보의 열람청구를 접수 ‧ 처리하는 부서</h4>
                            <p className="text">
                                정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. <br />
                                ㈜오토웰즈는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
                            </p>
                            <p className="sm_text">
                                ‣ 개인정보 열람청구 접수·처리 부서 <br />
                                부서명 : 임원실 <br />
                                담당자 : 곽건호 <br />
                                연락처 : 010-3287-3222, 사무실 전화번호 : 062-372-3731 <br />
                                이메일 : andrew.kwak.2025@gmail.com <br />
                                팩스번호 : 062-372-3735
                            </p>
                            <h4 className="sub_tit">제11조 정보주체의 권익침해에 대한 구제방법</h4>
                            <p className="text">
                                ① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고 센터센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
                            </p>
                            <p className="sm_text">
                                1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)
                                <br />
                                2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)
                                <br />
                                3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)
                                <br />
                                4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
                            </p>
                            <p className="text">② ㈜오토웰즈는 정보주체의 개인정보자기결정권을 보장하고, 개인정보침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다.</p>
                            <p className="sm_text">
                                ‣ 개인정보보호 관련 고객 상담 및 신고 <br />
                                부서명 : 임원실
                                <br />
                                담당자 : 곽건호
                                <br />
                                연락처 : 010-3287-3222, 사무실 전화번호 : 062-372-3731 <br />
                                이메일 : andrew.kwak.2025@gmail.com
                                <br />
                                팩스번호 : 062-372-3735
                            </p>
                            <p className="text">
                                ③ 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수
                                있습니다.{" "}
                            </p>
                            <p className="sm_text"> ‣ 중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)</p>
                            <h4 className="sub_tit">제12조 개인정보 처리방침의 변경에 관한 사항</h4>
                            <p className="text">
                                ① 이 개인정보 처리방침은 2022. 11. 15부터 적용됩니다. <br />② 추후 법령∙정책 또는 보안기술의 변경에 따라 내용의 추가∙삭제 및 수정이 있을 시에는 회사의 홈페이지를 통해 변경 사유 및 내용 등을 공지하도록 하겠습니다.
                            </p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("동의하기")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {lng == "en" && (
                <div className="input-area">
                    <div className="step_area">Privacy policy</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("Privacy Policy Guide")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                AUTOWELLS Co., Ltd. complies with the Personal Information Protection Act and relevant laws to protect the freedom and rights of data subjects, processes personal information lawfully, and manages it safely. In accordance with Article 30 of the Personal Information
                                Protection Act, this Privacy Policy is established and disclosed to inform data subjects of the procedures and standards related to the processing of personal information, and to ensure that complaints are handled promptly and smoothly.
                            </p>
                            <h4 className="sub_tit">Article 1 Purpose of Processing Personal Information</h4>
                            <p className="text">
                                AUTOWELLS Co., Ltd. processes personal information for the following purposes. The processed personal information will not be used for any purpose other than the following, and if the purpose of use is changed, necessary measures such as obtaining separate consent
                                will be taken in accordance with Article 18 of the Personal Information Protection Act.
                            </p>
                            <p className="text">
                                1. Biometric Information
                                <br />
                                Biometric information (heart rate, respiratory rate, occupancy detection values) is processed for research purposes related to the abnormality detection system.
                            </p>
                            <h4 className="sub_tit">Article 2 Processing and Retention Period of Personal Information</h4>
                            <p className="text">
                                ① AUTOWELLS Co., Ltd. processes and retains personal information within the personal information retention and usage period provided by law or the period agreed upon when collecting personal information from the data subject.
                                <br />② The processing and retention periods for each type of personal information are as follows:
                            </p>
                            <p className="sm_text">
                                1. Membership registration and management: Until withdrawal from the corporate/organization website. However, in the following cases, until the relevant reason is resolved:
                                <br />
                                1) When an investigation or inquiry due to a violation of related laws is in progress, until the end of the investigation/inquiry.
                                <br />
                                <br />
                                2. Provision of goods or services: Until the completion of supply and settlement of payment. However, in the following cases, until the relevant period ends:
                                <br />
                                1) Records related to transactions under the Act on the Consumer Protection in Electronic Commerce, etc.
                                <br />
                                - Records on advertising and display: 6 months
                                <br />
                                - Records on contracts, cancellations, payments, and supply of goods: 5 years <br />
                                - Records on consumer complaints or dispute resolution: 3 years
                                <br />
                                <br />
                                2) Retention of communication confirmation data under the Protection of Communications Secrets Act:
                                <br />
                                - Subscriber’s telecommunications date and time, start/end time, other party’s number, usage, originating base station location data: 1 year <br />
                                - Computer communication, internet log records, access trace data: 3 months
                                <br />
                                <br />
                                3) “Biometric feature information” (sensitive information) is processed under Article 23 of the Personal Information Protection Act.
                                <br />
                                <br />
                                3. Biometric information: Until membership withdrawal <br />
                                1) When an investigation or inquiry due to a violation of related laws is in progress, until the end of the investigation/inquiry.
                            </p>
                            <h4 className="sub_tit">Article 3 Items of Personal Information Processed</h4>
                            <p className="text">AUTOWELLS Co., Ltd. processes the following items of personal information:</p>
                            <p className="text">
                                1. Membership registration and management - Name, date of birth, address, phone number, email address
                                <br />
                                2. Provision of goods or services - Name, date of birth, address, phone number, email address
                                <br />
                                3. Biometric information - Heart rate, respiratory rate, occupancy detection values
                            </p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="20%" />
                                        <col width="20%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Category</th>
                                            <th>Purpose of Collection</th>
                                            <th>Items Collected</th>
                                            <th>Retention and Usage Period</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Membership registration and management</td>
                                            <td>
                                                Confirmation of membership intention, identification and authentication for membership services, maintaining and managing membership status, preventing misuse of services, verifying parental consent for children under 14, providing notifications, and
                                                handling complaints.
                                            </td>
                                            <td>Name, date of birth, address, phone number, email address</td>
                                            <td>
                                                Until membership withdrawal <br />※ However, in the case of an investigation or inquiry due to violation of laws, until the investigation/inquiry ends.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Provision of goods or <br />
                                                services
                                            </td>
                                            <td>Delivery of goods, service provision, content provision, personalized services, identity verification, and age verification.</td>
                                            <td>Name, date of birth, address, phone number, email address</td>
                                            <td>
                                                Until completion of supply and settlement of payment <br />※ However, in cases where retention is required by law, until that period ends.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Biometric information</td>
                                            <td>Research on abnormality detection system</td>
                                            <td>Heart rate, respiratory rate, occupancy detection values</td>
                                            <td>
                                                Until membership withdrawal <br />※ However, in the case of an investigation or inquiry due to violation of laws, until the investigation/inquiry ends.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h4 className="sub_tit">Article 4 Provision of Personal Information to Third Parties</h4>
                            <p className="text">
                                ① AUTOWELLS Co., Ltd. processes personal information only within the scope specified for the purpose of processing, and provides personal information to third parties only in cases falling under Articles 17 and 18 of the Personal Information Protection Act, such as
                                with the consent of the data subject or as required by law. <br />② AUTOWELLS Co., Ltd. may provide personal information with the data subject’s consent to the minimum extent necessary for smooth service provision.
                            </p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="40%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Category</th>
                                            <th>Purpose of Collection</th>
                                            <th>Items Collected</th>
                                            <th>Retention and Usage Period</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Government Agencies</td>
                                            <td>Specific information provision</td>
                                            <td>Name, date of birth, address, phone number, email address, biometric information</td>
                                            <td>
                                                Until membership withdrawal <br />※ However, in the case of an investigation or inquiry due to violation of laws, until the investigation/inquiry ends.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p className="text">
                                ③ AUTOWELLS Co., Ltd. may provide personal information to relevant institutions without the consent of the data subject in cases of emergencies such as disasters, infectious diseases, imminent danger to life or body, or urgent risk of property loss.
                            </p>
                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Category</th>
                                            <th>Legal Basis</th>
                                            <th>Recipient</th>
                                            <th>Personal Information Provided</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Protection of individuals at risk of suicide</td>
                                            <td>Suicide Prevention Act</td>
                                            <td>
                                                Police Department <br />
                                                Fire Department
                                            </td>
                                            <td>• (For information and communication service providers) Name, resident registration number (or date of birth if not available), address, phone number, ID, email address, and personal location information of the person subject to emergency rescue.</td>
                                        </tr>
                                        <tr>
                                            <td>Emergency rescue request response</td>
                                            <td>Location Information Act</td>
                                            <td>Fire Department</td>
                                            <td>• Personal location information</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h4 className="sub_tit">Article 5 Procedures and Methods for Destroying Personal Information</h4>
                            <p className="text">
                                ① AUTOWELLS Co., Ltd. destroys personal information without delay when the retention period expires, the purpose of processing is achieved, or the information becomes unnecessary. <br />② If personal information must continue to be preserved despite the expiration of
                                the agreed retention period or achievement of the processing purpose due to legal obligations, it will be moved to a separate database (DB) or stored in a different location.
                                <br />③ The procedures and methods of destroying personal information are as follows:
                            </p>
                            <p className="text">
                                1. Destruction procedure
                                <br />
                                AUTOWELLS Co., Ltd. selects the personal information to be destroyed and obtains approval from the Personal Information Protection Officer before destruction.
                                <br />
                                <br />
                                2. Destruction method
                                <br />
                                Personal information recorded/stored in electronic files is destroyed so that it cannot be restored, and personal information recorded/stored in paper documents is shredded or incinerated.
                            </p>
                            <p className="sub_tit">Article 6 Rights and Obligations of Data Subjects and Legal Representatives</p>
                            <p className="text">
                                ① Data subjects may exercise rights such as access, correction, deletion, and suspension of processing of personal information against AUTOWELLS Co., Ltd. at any time.
                                <br />
                                ※ For children under 14, such requests must be made by the legal representative. For minors aged 14 or older, rights may be exercised by themselves or through their legal representative.
                                <br />
                                ② These rights may be exercised via written request, email, or fax in accordance with Article 41(1) of the Enforcement Decree of the Personal Information Protection Act, and AUTOWELLS Co., Ltd. will promptly take action.
                                <br />
                                ③ Rights may also be exercised through a legal representative or an agent authorized by the data subject. In this case, a power of attorney form (Prescribed Form No. 11 of the Notification on the Processing of Personal Information, No. 2020-7) must be submitted.
                                <br />
                                ④ Requests for access or suspension of processing may be restricted under Article 35(4) and Article 37(2) of the Personal Information Protection Act.
                                <br />
                                ⑤ Requests for correction or deletion may not be accepted where the personal information is specified as a subject of collection by other laws.
                                <br />⑥ AUTOWELLS Co., Ltd. verifies the identity of the requesting person or their representative when rights such as access, correction, deletion, or suspension are exercised.
                            </p>
                            <h4 className="sub_tit">Article 7 Measures to Ensure the Security of Personal Information</h4>
                            <p className="text">
                                1. Administrative measures: Establishment and implementation of internal management plans, operation of dedicated organizations, regular employee training
                                <br />
                                2. Technical measures: Management of access rights to personal information processing systems, installation of access control systems, encryption of personal information, installation and update of security programs
                                <br />
                                3. Physical measures: Access control to computer rooms, data storage rooms, etc.
                            </p>
                            <h4 className="sub_tit">Article 8 Installation, Operation, and Refusal of Devices that Collect Personal Information Automatically</h4>
                            <p className="text">AUTOWELLS Co., Ltd. does not use ‘cookies’ that store and retrieve the user’s information.</p>
                            <h4 className="sub_tit">Article 9 Personal Information Protection Officer</h4>
                            <p className="text">① AUTOWELLS Co., Ltd. has designated the following Personal Information Protection Officer who is responsible for overseeing personal information processing and handling complaints and remedies related to personal information.</p>
                            <p className="sm_text">
                                ‣ Personal Information Protection Officer <br />
                                Name: Geonho Kwak
                                <br />
                                Position: CEO
                                <br />
                                Mobile: 010-3287-3222
                                <br />
                                Office: 062-372-3731
                                <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Fax: 062-372-3735
                                <br />※ Connected to the personal information department.
                            </p>
                            <h4 className="sub_tit">Article 10 Department Handling Requests for Access to Personal Information</h4>
                            <p className="text">
                                Data subjects may request access to personal information pursuant to Article 35 of the Personal Information Protection Act from the department below. <br />
                                AUTOWELLS Co., Ltd. will make efforts to process such requests promptly.
                            </p>
                            <p className="sm_text">
                                ‣ Department for Access Requests <br />
                                Department: Executive Office <br />
                                Contact: Geonho Kwak <br />
                                Mobile: 010-3287-3222, Office: 062-372-3731 <br />
                                Email: andrew.kwak.2025@gmail.com <br />
                                Fax: 062-372-3735
                            </p>
                            <h4 className="sub_tit">Article 11 Remedies for Infringement of Rights</h4>
                            <p className="text">
                                ① Data subjects may seek dispute resolution or consultation regarding personal information infringements by contacting the Personal Information Dispute Mediation Committee or the Korea Internet & Security Agency Personal Information Infringement Report Center. For
                                other reports or consultations regarding personal information infringements, please contact the organizations below.
                            </p>
                            <p className="sm_text">
                                1. Personal Information Dispute Mediation Committee: 1833-6972 (www.kopico.go.kr)
                                <br />
                                2. Personal Information Infringement Report Center: 118 (privacy.kisa.or.kr)
                                <br />
                                3. Supreme Prosecutors’ Office: 1301 (www.spo.go.kr)
                                <br />
                                4. National Police Agency: 182 (ecrm.cyber.go.kr)
                            </p>
                            <p className="text">
                                ② AUTOWELLS Co., Ltd. is committed to protecting the personal information self-determination rights of data subjects and providing counseling and remedies for personal information infringements. Please contact the following department for inquiries or complaints.
                            </p>
                            <p className="sm_text">
                                ‣ Personal Information Consultation and Reporting <br />
                                Department: Executive Office
                                <br />
                                Contact: Geonho Kwak
                                <br />
                                Mobile: 010-3287-3222, Office: 062-372-3731 <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Fax: 062-372-3735
                            </p>
                            <p className="text">
                                ③ Data subjects who have suffered infringement of rights or interests due to a disposition or omission by the head of a public institution in response to a request under Articles 35 (Access), 36 (Correction/Deletion), or 37 (Suspension of Processing) of the Personal
                                Information Protection Act may file an administrative appeal in accordance with the Administrative Appeals Act.
                            </p>
                            <p className="sm_text"> ‣ Central Administrative Appeals Commission: 110 (www.simpan.go.kr)</p>
                            <h4 className="sub_tit">Article 12 Changes to the Privacy Policy</h4>
                            <p className="text">
                                ① This Privacy Policy shall take effect from November 15, 2022. <br />② If there are any additions, deletions, or modifications due to changes in laws, policies, or security technologies, the reason for and details of the changes will be notified through the company’s
                                website.
                            </p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("Agree")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "cn" && (
                <div className="input-area">
                    <div className="step_area">隐私政策</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("隐私政策指南")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">AUTOWELLS有限公司遵守《个人信息保护法》及相关法律规定，依法处理个人信息并安全管理，以保护信息主体的自由和权利。根据《个人信息保护法》第30条，特此制定并公开本隐私政策，以告知信息主体有关个人信息处理的程序和标准，并确保能够及时顺畅地处理相关投诉。</p>
                            <h4 className="sub_tit">第1条 个人信息处理目的</h4>
                            <p className="text">AUTOWELLS有限公司为以下目的处理个人信息。处理的个人信息不会用于以下目的以外的用途，如用途发生变更，将根据《个人信息保护法》第18条采取必要措施，例如获得单独同意。</p>
                            <p className="text">
                                1. 生物信息
                                <br />
                                为异常检测系统研究之目的，处理个人生物信息（心率、呼吸率、在室检测值）。
                            </p>

                            <h4 className="sub_tit">第2条 个人信息的处理及保存期限</h4>
                            <p className="text">
                                ① AUTOWELLS有限公司在法律规定的个人信息保存和使用期限内，或在收集时经信息主体同意的期限内处理和保存个人信息。
                                <br />② 各类个人信息的处理及保存期限如下：
                            </p>
                            <p className="sm_text">
                                1. 网站会员注册及管理：至退出公司/团体网站为止。但如有以下情况，则至相关情况结束为止。
                                <br />
                                1) 因违反相关法律正在进行调查时，至该调查结束为止。
                                <br />
                                <br />
                                2. 商品或服务提供：至商品/服务提供完成及费用结算完成为止。但如有以下情况，则至相关期间结束为止。
                                <br />
                                1) 《电子商务等消费者保护法》规定的交易记录保存：
                                <br />
                                - 广告展示记录：6个月
                                <br />
                                - 合同、撤销、付款、供应记录：5年
                                <br />
                                - 消费者投诉或纠纷处理记录：3年
                                <br />
                                <br />
                                2) 《通信保密法》规定的通信确认资料保存：
                                <br />
                                - 用户通信日期时间、开始/结束时间、对方号码、使用量、发信基站位置：1年
                                <br />
                                - 计算机通信、互联网日志记录、接入追踪资料：3个月
                                <br />
                                <br />
                                3) 《个人信息保护法》第23条规定的敏感信息（生物识别特征信息）
                                <br />
                                <br />
                                3. 生物信息：至会员退出为止
                                <br />
                                1) 如因违反相关法律正在进行调查，则至该调查结束为止
                            </p>

                            <h4 className="sub_tit">第3条 处理的个人信息项目</h4>
                            <p className="text">AUTOWELLS有限公司处理以下个人信息项目：</p>
                            <p className="text">
                                1. 会员注册及管理 - 姓名、出生日期、地址、电话号码、电子邮件地址
                                <br />
                                2. 商品或服务提供 - 姓名、出生日期、地址、电话号码、电子邮件地址
                                <br />
                                3. 生物信息 - 心率、呼吸率、在室检测值
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>分类</th>
                                            <th>收集目的</th>
                                            <th>收集项目</th>
                                            <th>保存及使用期限</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>会员注册及管理</td>
                                            <td>确认注册意愿、身份认证、维持会员资格、防止服务滥用、确认法定代理人同意（14岁以下儿童）、通知与投诉处理</td>
                                            <td>姓名、出生日期、地址、电话号码、电子邮件地址</td>
                                            <td>至会员退出为止 ※如有调查，则至结束为止</td>
                                        </tr>
                                        <tr>
                                            <td>商品/服务提供</td>
                                            <td>商品配送、服务提供、内容提供、个性化服务、身份验证、年龄验证</td>
                                            <td>姓名、出生日期、地址、电话号码、电子邮件地址</td>
                                            <td>至提供/结算完成为止 ※法律要求的情况下按期限保存</td>
                                        </tr>
                                        <tr>
                                            <td>生物信息</td>
                                            <td>异常检测系统研究</td>
                                            <td>心率、呼吸率、在室检测值</td>
                                            <td>至会员退出为止 ※如有调查，则至结束为止</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">第4条 个人信息向第三方提供</h4>
                            <p className="text">
                                ① AUTOWELLS有限公司仅在处理目的范围内处理个人信息，仅在《个人信息保护法》第17条及第18条规定的情况下（如信息主体同意或法律要求）才会提供给第三方。
                                <br />② 为顺利提供服务，经信息主体同意，可能在必要范围内提供。
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>分类</th>
                                            <th>收集目的</th>
                                            <th>收集项目</th>
                                            <th>保存及使用期限</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>国家机关</td>
                                            <td>特定信息提供</td>
                                            <td>姓名、出生日期、地址、电话、邮箱、生物信息</td>
                                            <td>至会员退出为止 ※如有调查，则至结束为止</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p className="text">③ 在灾害、传染病、生命或身体紧急危险、财产损失等紧急情况下，AUTOWELLS有限公司可在未征得信息主体同意的情况下向相关机构提供个人信息。</p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("同意")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "vi" && (
                <div className="input-area">
                    <div className="step_area">Chính sách bảo mật</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("Hướng dẫn Chính sách Bảo mật")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                Công ty AUTOWELLS tuân thủ Luật Bảo vệ Thông tin Cá nhân và các quy định pháp luật liên quan, xử lý hợp pháp và quản lý an toàn thông tin cá nhân nhằm bảo vệ quyền tự do và quyền lợi của chủ thể dữ liệu. Theo Điều 30 của Luật Bảo vệ Thông tin Cá nhân, Chính sách bảo
                                mật này được thiết lập và công bố để thông báo cho chủ thể dữ liệu về các thủ tục và tiêu chuẩn liên quan đến việc xử lý thông tin cá nhân, đồng thời đảm bảo xử lý khiếu nại nhanh chóng và hiệu quả.
                            </p>

                            <h4 className="sub_tit">Điều 1. Mục đích xử lý thông tin cá nhân</h4>
                            <p className="text">
                                AUTOWELLS xử lý thông tin cá nhân cho các mục đích sau. Thông tin cá nhân sẽ không được sử dụng ngoài các mục đích này, và nếu có thay đổi, AUTOWELLS sẽ thực hiện các biện pháp cần thiết như xin ý kiến đồng ý riêng biệt theo Điều 18 Luật Bảo vệ Thông tin Cá nhân.
                            </p>
                            <p className="text">
                                1. Thông tin sinh trắc học
                                <br />
                                Thông tin sinh trắc học (nhịp tim, nhịp thở, giá trị phát hiện hiện diện) được xử lý cho mục đích nghiên cứu hệ thống phát hiện bất thường.
                            </p>

                            <h4 className="sub_tit">Điều 2. Thời hạn xử lý và lưu giữ thông tin cá nhân</h4>
                            <p className="text">
                                ① AUTOWELLS xử lý và lưu giữ thông tin cá nhân trong thời hạn theo quy định của pháp luật hoặc thời hạn đã được sự đồng ý của chủ thể dữ liệu khi thu thập.
                                <br />② Thời hạn xử lý và lưu giữ cho từng loại thông tin cá nhân như sau:
                            </p>
                            <p className="sm_text">
                                1. Đăng ký và quản lý thành viên: cho đến khi hủy bỏ tư cách thành viên. Tuy nhiên, trong trường hợp có điều tra hoặc truy cứu do vi phạm pháp luật, sẽ được giữ cho đến khi kết thúc điều tra.
                                <br />
                                <br />
                                2. Cung cấp hàng hóa hoặc dịch vụ: cho đến khi hoàn tất cung cấp và thanh toán. Tuy nhiên, trong các trường hợp sau, giữ cho đến hết thời hạn liên quan:
                                <br />
                                1) Lưu trữ hồ sơ giao dịch theo Luật Bảo vệ Người tiêu dùng trong Thương mại điện tử:
                                <br />- Hồ sơ quảng cáo: 6 tháng
                                <br />- Hồ sơ hợp đồng, hủy, thanh toán, cung cấp hàng hóa: 5 năm
                                <br />- Hồ sơ khiếu nại hoặc giải quyết tranh chấp: 3 năm
                                <br />
                                <br />
                                2) Lưu giữ dữ liệu xác nhận thông tin liên lạc theo Luật Bảo vệ Bí mật Thông tin liên lạc:
                                <br />- Ngày giờ liên lạc, thời gian bắt đầu/kết thúc, số điện thoại đối tác, lượng sử dụng, vị trí trạm phát: 1 năm
                                <br />- Nhật ký internet, dữ liệu truy cập: 3 tháng
                                <br />
                                <br />
                                3) Thông tin sinh trắc học (thông tin nhạy cảm) được xử lý theo Điều 23 của Luật Bảo vệ Thông tin Cá nhân.
                                <br />
                                <br />
                                3. Thông tin sinh trắc học: cho đến khi hủy bỏ tư cách thành viên
                            </p>

                            <h4 className="sub_tit">Điều 3. Các mục thông tin cá nhân được xử lý</h4>
                            <p className="text">AUTOWELLS xử lý các mục thông tin cá nhân sau:</p>
                            <p className="text">
                                1. Đăng ký và quản lý thành viên - Họ tên, ngày sinh, địa chỉ, số điện thoại, email
                                <br />
                                2. Cung cấp hàng hóa/dịch vụ - Họ tên, ngày sinh, địa chỉ, số điện thoại, email
                                <br />
                                3. Thông tin sinh trắc học - Nhịp tim, nhịp thở, giá trị phát hiện hiện diện
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>Phân loại</th>
                                            <th>Mục đích thu thập</th>
                                            <th>Mục thông tin</th>
                                            <th>Thời hạn lưu giữ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Đăng ký thành viên</td>
                                            <td>Xác nhận ý định, xác minh, duy trì tình trạng thành viên, ngăn chặn lạm dụng dịch vụ, xác nhận đồng ý của người giám hộ đối với trẻ em dưới 14 tuổi, thông báo và xử lý khiếu nại</td>
                                            <td>Họ tên, ngày sinh, địa chỉ, số điện thoại, email</td>
                                            <td>Cho đến khi hủy bỏ thành viên ※ Trong trường hợp có điều tra, cho đến khi kết thúc</td>
                                        </tr>
                                        <tr>
                                            <td>Cung cấp hàng hóa/dịch vụ</td>
                                            <td>Giao hàng, cung cấp dịch vụ, xác minh danh tính, xác minh độ tuổi</td>
                                            <td>Họ tên, ngày sinh, địa chỉ, số điện thoại, email</td>
                                            <td>Cho đến khi hoàn tất cung cấp và thanh toán ※ Nếu pháp luật yêu cầu, lưu giữ cho đến khi hết hạn</td>
                                        </tr>
                                        <tr>
                                            <td>Thông tin sinh trắc học</td>
                                            <td>Nghiên cứu hệ thống phát hiện bất thường</td>
                                            <td>Nhịp tim, nhịp thở, giá trị phát hiện hiện diện</td>
                                            <td>Cho đến khi hủy bỏ thành viên ※ Trong trường hợp có điều tra, cho đến khi kết thúc</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">Điều 4. Cung cấp thông tin cá nhân cho bên thứ ba</h4>
                            <p className="text">
                                ① AUTOWELLS chỉ xử lý trong phạm vi mục đích và chỉ cung cấp cho bên thứ ba trong các trường hợp theo Điều 17 và 18 của Luật Bảo vệ Thông tin Cá nhân (có sự đồng ý hoặc theo pháp luật).
                                <br />② Với sự đồng ý của chủ thể dữ liệu, có thể cung cấp trong phạm vi tối thiểu cần thiết để cung cấp dịch vụ.
                            </p>

                            <h4 className="sub_tit">Điều 5. Quy trình và phương thức tiêu hủy</h4>
                            <p className="text">
                                ① Thông tin cá nhân sẽ được tiêu hủy ngay khi hết thời hạn lưu giữ, đạt được mục đích xử lý hoặc không còn cần thiết.
                                <br />② Nếu pháp luật yêu cầu phải tiếp tục lưu giữ, sẽ chuyển sang cơ sở dữ liệu riêng hoặc lưu giữ tại nơi khác.
                                <br />③ Quy trình: lựa chọn thông tin cần hủy, được phê duyệt bởi Người phụ trách Bảo vệ Thông tin, sau đó tiêu hủy.
                                <br />④ Phương thức: dữ liệu điện tử sẽ bị xóa vĩnh viễn, tài liệu giấy sẽ bị nghiền hoặc đốt.
                            </p>

                            <h4 className="sub_tit">Điều 6. Quyền và nghĩa vụ của chủ thể dữ liệu</h4>
                            <p className="text">Chủ thể dữ liệu có quyền yêu cầu truy cập, chỉnh sửa, xóa, tạm ngừng xử lý thông tin cá nhân bất cứ lúc nào. Trẻ dưới 14 tuổi cần có người giám hộ thực hiện thay.</p>

                            <h4 className="sub_tit">Điều 7. Biện pháp bảo mật</h4>
                            <p className="text">
                                - Biện pháp quản lý: kế hoạch quản lý nội bộ, đào tạo nhân viên
                                <br />- Biện pháp kỹ thuật: kiểm soát quyền truy cập, mã hóa, chương trình bảo mật
                                <br />- Biện pháp vật lý: kiểm soát ra vào phòng máy, kho lưu trữ
                            </p>

                            <h4 className="sub_tit">Điều 8. Cookie</h4>
                            <p className="text">AUTOWELLS không sử dụng cookie.</p>

                            <h4 className="sub_tit">Điều 9. Người phụ trách bảo vệ thông tin cá nhân</h4>
                            <p className="sm_text">
                                Họ tên: Geonho Kwak
                                <br />
                                Chức vụ: Giám đốc điều hành
                                <br />
                                Điện thoại: 010-3287-3222 / 062-372-3731
                                <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Fax: 062-372-3735
                            </p>

                            <h4 className="sub_tit">Điều 10. Bộ phận tiếp nhận yêu cầu</h4>
                            <p className="sm_text">
                                Bộ phận: Văn phòng điều hành
                                <br />
                                Người liên hệ: Geonho Kwak
                                <br />
                                Điện thoại: 010-3287-3222 / 062-372-3731
                                <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Fax: 062-372-3735
                            </p>

                            <h4 className="sub_tit">Điều 11. Biện pháp khắc phục vi phạm quyền lợi</h4>
                            <p className="sm_text">
                                - Ủy ban hòa giải tranh chấp thông tin cá nhân: 1833-6972 (www.kopico.go.kr)
                                <br />
                                - Trung tâm báo cáo vi phạm thông tin cá nhân KISA: 118 (privacy.kisa.or.kr)
                                <br />
                                - Viện kiểm sát tối cao: 1301 (www.spo.go.kr)
                                <br />- Cơ quan cảnh sát quốc gia: 182 (ecrm.cyber.go.kr)
                            </p>

                            <h4 className="sub_tit">Điều 12. Thay đổi chính sách</h4>
                            <p className="text">Chính sách này có hiệu lực từ ngày 15/11/2022. Nếu có thay đổi về luật pháp, chính sách hoặc công nghệ bảo mật, AUTOWELLS sẽ thông báo chi tiết trên trang web.</p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("Đồng ý")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "th" && (
                <div className="input-area">
                    <div className="step_area">นโยบายความเป็นส่วนตัว</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("คู่มือนโยบายความเป็นส่วนตัว")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                บริษัท AUTOWELLS ปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลและกฎหมายที่เกี่ยวข้อง เพื่อคุ้มครองสิทธิและเสรีภาพของเจ้าของข้อมูลส่วนบุคคล ดำเนินการประมวลผลข้อมูลอย่างถูกต้องตามกฎหมายและบริหารจัดการอย่างปลอดภัย ตามมาตรา 30 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                                บริษัทฯ จึงได้จัดทำนโยบายความเป็นส่วนตัวฉบับนี้ขึ้นเพื่อแจ้งให้เจ้าของข้อมูลทราบถึงขั้นตอนและมาตรฐานที่เกี่ยวข้อง รวมทั้งเพื่อให้สามารถจัดการข้อร้องเรียนได้อย่างรวดเร็วและมีประสิทธิภาพ
                            </p>

                            <h4 className="sub_tit">มาตรา 1 วัตถุประสงค์ของการประมวลผลข้อมูลส่วนบุคคล</h4>
                            <p className="text">
                                บริษัท AUTOWELLS ประมวลผลข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้ และจะไม่ใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากนี้ หากมีการเปลี่ยนแปลงวัตถุประสงค์ บริษัทฯ จะดำเนินการตามที่กฎหมายกำหนด เช่น การขอความยินยอมเพิ่มเติมตามมาตรา 18 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                            </p>
                            <p className="text">
                                1. ข้อมูลชีวภาพ
                                <br />
                                ข้อมูลชีวภาพ (อัตราการเต้นของหัวใจ อัตราการหายใจ ค่าการตรวจจับการมีอยู่) ถูกนำมาใช้เพื่อการวิจัยระบบตรวจจับความผิดปกติ
                            </p>

                            <h4 className="sub_tit">มาตรา 2 ระยะเวลาในการประมวลผลและเก็บรักษาข้อมูล</h4>
                            <p className="text">
                                ① บริษัท AUTOWELLS จะเก็บรักษาข้อมูลส่วนบุคคลตามระยะเวลาที่กฎหมายกำหนดหรือระยะเวลาที่เจ้าของข้อมูลได้ให้ความยินยอมไว้
                                <br />② ระยะเวลาการประมวลผลและเก็บรักษาข้อมูลมีดังนี้:
                            </p>
                            <p className="sm_text">
                                1. การลงทะเบียนและจัดการสมาชิก: เก็บไว้จนกว่าจะยกเลิกการเป็นสมาชิก แต่หากมีการสืบสวนหรือสอบสวน จะเก็บไว้จนกว่าการสืบสวนจะสิ้นสุด
                                <br />
                                <br />
                                2. การให้บริการหรือจัดหาสินค้า: เก็บไว้จนกว่าจะเสร็จสิ้นการให้บริการและการชำระเงิน แต่หากกฎหมายกำหนดไว้เป็นกรณีพิเศษ จะเก็บรักษาตามที่กฎหมายกำหนด
                                <br />
                                - บันทึกการโฆษณา: 6 เดือน
                                <br />
                                - บันทึกสัญญา การยกเลิก การชำระเงิน และการส่งมอบสินค้า: 5 ปี
                                <br />
                                - บันทึกการร้องเรียนหรือการระงับข้อพิพาท: 3 ปี
                                <br />
                                <br />
                                3. ข้อมูลชีวภาพ: เก็บไว้จนกว่าจะยกเลิกการเป็นสมาชิก
                            </p>

                            <h4 className="sub_tit">มาตรา 3 ประเภทข้อมูลส่วนบุคคลที่เก็บรวบรวม</h4>
                            <p className="text">บริษัท AUTOWELLS จัดเก็บข้อมูลดังต่อไปนี้:</p>
                            <p className="text">
                                1. ข้อมูลสมาชิก - ชื่อ วันเดือนปีเกิด ที่อยู่ หมายเลขโทรศัพท์ อีเมล
                                <br />
                                2. การให้บริการหรือจัดหาสินค้า - ชื่อ วันเดือนปีเกิด ที่อยู่ หมายเลขโทรศัพท์ อีเมล
                                <br />
                                3. ข้อมูลชีวภาพ - อัตราการเต้นของหัวใจ อัตราการหายใจ ค่าการตรวจจับการมีอยู่
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>ประเภท</th>
                                            <th>วัตถุประสงค์</th>
                                            <th>รายการข้อมูล</th>
                                            <th>ระยะเวลาเก็บรักษา</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>การสมัครสมาชิก</td>
                                            <td>ยืนยันความประสงค์, การยืนยันตัวตน, รักษาสถานะสมาชิก, ป้องกันการใช้บริการที่ไม่ถูกต้อง, การยินยอมของผู้ปกครองสำหรับเด็กต่ำกว่า 14 ปี, การแจ้งเตือน, การจัดการข้อร้องเรียน</td>
                                            <td>ชื่อ วันเดือนปีเกิด ที่อยู่ เบอร์โทรศัพท์ อีเมล</td>
                                            <td>จนกว่าจะยกเลิกการเป็นสมาชิก ※ หากมีการสืบสวน เก็บจนกว่าจะสิ้นสุด</td>
                                        </tr>
                                        <tr>
                                            <td>การให้บริการ/สินค้า</td>
                                            <td>การจัดส่ง การให้บริการ การยืนยันตัวตน การตรวจสอบอายุ</td>
                                            <td>ชื่อ วันเดือนปีเกิด ที่อยู่ เบอร์โทรศัพท์ อีเมล</td>
                                            <td>จนกว่าจะเสร็จสิ้นบริการและการชำระเงิน ※ หากกฎหมายกำหนด ต้องเก็บตามกำหนด</td>
                                        </tr>
                                        <tr>
                                            <td>ข้อมูลชีวภาพ</td>
                                            <td>การวิจัยระบบตรวจจับความผิดปกติ</td>
                                            <td>อัตราการเต้นหัวใจ อัตราการหายใจ ค่าการตรวจจับการมีอยู่</td>
                                            <td>จนกว่าจะยกเลิกการเป็นสมาชิก ※ หากมีการสืบสวน เก็บจนกว่าจะสิ้นสุด</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">มาตรา 4 การเปิดเผยข้อมูลส่วนบุคคลแก่บุคคลที่สาม</h4>
                            <p className="text">บริษัท AUTOWELLS จะเปิดเผยข้อมูลส่วนบุคคลแก่บุคคลที่สามเฉพาะเมื่อมีการยินยอมจากเจ้าของข้อมูลหรือเมื่อกฎหมายกำหนด</p>

                            <h4 className="sub_tit">มาตรา 5 ขั้นตอนและวิธีการทำลายข้อมูลส่วนบุคคล</h4>
                            <p className="text">ข้อมูลส่วนบุคคลที่หมดความจำเป็นจะถูกทำลายทันที ข้อมูลอิเล็กทรอนิกส์จะถูกลบอย่างถาวร เอกสารกระดาษจะถูกทำลายด้วยเครื่องทำลายเอกสารหรือการเผา</p>

                            <h4 className="sub_tit">มาตรา 6 สิทธิของเจ้าของข้อมูล</h4>
                            <p className="text">เจ้าของข้อมูลสามารถขอเข้าถึง แก้ไข ลบ หรือขอหยุดการประมวลผลข้อมูลส่วนบุคคลได้ทุกเมื่อ สำหรับเด็กอายุต่ำกว่า 14 ปี ต้องดำเนินการโดยผู้ปกครอง</p>

                            <h4 className="sub_tit">มาตรา 7 มาตรการรักษาความปลอดภัย</h4>
                            <p className="text">
                                - มาตรการบริหารจัดการ: แผนการจัดการภายใน การอบรมพนักงาน
                                <br />- มาตรการทางเทคนิค: การควบคุมสิทธิ์เข้าถึง การเข้ารหัส โปรแกรมรักษาความปลอดภัย
                                <br />- มาตรการทางกายภาพ: การควบคุมการเข้าถึงห้องเซิร์ฟเวอร์และห้องเก็บข้อมูล
                            </p>

                            <h4 className="sub_tit">มาตรา 8 คุกกี้</h4>
                            <p className="text">บริษัท AUTOWELLS ไม่ใช้คุกกี้ (Cookies)</p>

                            <h4 className="sub_tit">มาตรา 9 ผู้รับผิดชอบคุ้มครองข้อมูลส่วนบุคคล</h4>
                            <p className="sm_text">
                                ชื่อ: Geonho Kwak
                                <br />
                                ตำแหน่ง: ประธานเจ้าหน้าที่บริหาร
                                <br />
                                โทรศัพท์: 010-3287-3222 / 062-372-3731
                                <br />
                                อีเมล: andrew.kwak.2025@gmail.com
                                <br />
                                แฟกซ์: 062-372-3735
                            </p>

                            <h4 className="sub_tit">มาตรา 10 หน่วยงานรับคำขอ</h4>
                            <p className="sm_text">
                                หน่วยงาน: สำนักงานผู้บริหาร
                                <br />
                                ผู้ติดต่อ: Geonho Kwak
                                <br />
                                โทรศัพท์: 010-3287-3222 / 062-372-3731
                                <br />
                                อีเมล: andrew.kwak.2025@gmail.com
                                <br />
                                แฟกซ์: 062-372-3735
                            </p>

                            <h4 className="sub_tit">มาตรา 11 วิธีการร้องเรียนเมื่อสิทธิถูกละเมิด</h4>
                            <p className="sm_text">
                                - คณะกรรมการไกล่เกลี่ยข้อพิพาทข้อมูลส่วนบุคคล: 1833-6972 (www.kopico.go.kr)
                                <br />
                                - ศูนย์รายงานข้อมูลส่วนบุคคล KISA: 118 (privacy.kisa.or.kr)
                                <br />
                                - สำนักงานอัยการสูงสุด: 1301 (www.spo.go.kr)
                                <br />- สำนักงานตำรวจแห่งชาติ: 182 (ecrm.cyber.go.kr)
                            </p>

                            <h4 className="sub_tit">มาตรา 12 การเปลี่ยนแปลงนโยบาย</h4>
                            <p className="text">นโยบายนี้มีผลตั้งแต่วันที่ 15 พฤศจิกายน 2022 หากมีการเปลี่ยนแปลงเกี่ยวกับกฎหมาย นโยบาย หรือเทคโนโลยี บริษัทฯ จะแจ้งรายละเอียดผ่านเว็บไซต์</p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("ยอมรับ")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "jp" && (
                <div className="input-area">
                    <div className="step_area">プライバシーポリシー</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("プライバシーポリシーガイド")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                AUTOWELLS株式会社は、「個人情報保護法」および関連法令を遵守し、情報主体の自由と権利を保護するために、個人情報を適法に処理し安全に管理しています。
                                「個人情報保護法」第30条に基づき、本プライバシーポリシーを策定・公開し、情報主体に個人情報処理に関する手続きと基準を通知し、苦情を迅速かつ円滑に処理できるようにします。
                            </p>

                            <h4 className="sub_tit">第1条 個人情報の処理目的</h4>
                            <p className="text">AUTOWELLS株式会社は、以下の目的で個人情報を処理します。処理された個人情報は、これら以外の目的では利用されず、利用目的が変更される場合は、「個人情報保護法」第18条に基づき、別途同意を得るなど必要な措置を講じます。</p>
                            <p className="text">
                                1. 生体情報
                                <br />
                                生体情報（心拍数、呼吸数、在室検知値）は、異常検知システムの研究目的で処理されます。
                            </p>

                            <h4 className="sub_tit">第2条 個人情報の処理および保有期間</h4>
                            <p className="text">
                                ① AUTOWELLS株式会社は、法令で定められた期間または収集時に情報主体から同意を得た期間内で個人情報を処理・保有します。
                                <br />② 各個人情報の処理および保有期間は次のとおりです。
                            </p>
                            <p className="sm_text">
                                1. 会員登録および管理：会員退会時まで。ただし、法令違反による調査が進行中の場合は、その調査終了時まで。
                                <br />
                                <br />
                                2. 商品またはサービス提供：提供完了および料金決済完了時まで。ただし、関連法令に基づき保存する場合は、その期間まで。
                                <br />
                                - 広告表示に関する記録：6か月
                                <br />
                                - 契約、取消、支払い、提供記録：5年
                                <br />
                                - 消費者苦情または紛争処理記録：3年
                                <br />
                                <br />
                                3. 生体情報：会員退会時まで。ただし、法令違反による調査が進行中の場合は、その調査終了時まで。
                            </p>

                            <h4 className="sub_tit">第3条 処理する個人情報の項目</h4>
                            <p className="text">AUTOWELLS株式会社は、以下の個人情報を処理します。</p>
                            <p className="text">
                                1. 会員登録および管理 - 氏名、生年月日、住所、電話番号、メールアドレス
                                <br />
                                2. 商品またはサービス提供 - 氏名、生年月日、住所、電話番号、メールアドレス
                                <br />
                                3. 生体情報 - 心拍数、呼吸数、在室検知値
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>区分</th>
                                            <th>収集目的</th>
                                            <th>収集項目</th>
                                            <th>保有期間</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>会員登録および管理</td>
                                            <td>登録意思確認、本人確認、会員資格維持、サービス不正利用防止、14歳未満の保護者同意確認、通知、苦情処理</td>
                                            <td>氏名、生年月日、住所、電話番号、メールアドレス</td>
                                            <td>退会時まで ※調査中の場合は終了時まで</td>
                                        </tr>
                                        <tr>
                                            <td>商品/サービス提供</td>
                                            <td>商品配送、サービス提供、本人確認、年齢確認</td>
                                            <td>氏名、生年月日、住所、電話番号、メールアドレス</td>
                                            <td>提供完了・決済完了時まで ※法令により保存する場合はその期間まで</td>
                                        </tr>
                                        <tr>
                                            <td>生体情報</td>
                                            <td>異常検知システム研究</td>
                                            <td>心拍数、呼吸数、在室検知値</td>
                                            <td>退会時まで ※調査中の場合は終了時まで</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">第4条 個人情報の第三者提供</h4>
                            <p className="text">AUTOWELLS株式会社は、情報主体の同意または法令に基づく場合を除き、個人情報を第三者に提供しません。</p>

                            <h4 className="sub_tit">第5条 個人情報の破棄手続きおよび方法</h4>
                            <p className="text">保有期間の経過、処理目的の達成などにより不要となった個人情報は、速やかに破棄します。電子ファイルは復元できない方法で削除し、紙文書はシュレッダーで裁断または焼却します。</p>

                            <h4 className="sub_tit">第6条 情報主体の権利</h4>
                            <p className="text">情報主体は、いつでも自身の個人情報の閲覧、訂正、削除、処理停止を求める権利があります。14歳未満の児童については保護者が行う必要があります。</p>

                            <h4 className="sub_tit">第7条 安全性確保措置</h4>
                            <p className="text">
                                - 管理的措置：内部管理計画の策定、従業員教育
                                <br />- 技術的措置：アクセス権限管理、暗号化、セキュリティプログラム
                                <br />- 物理的措置：サーバールーム、資料保管室へのアクセス制御
                            </p>

                            <h4 className="sub_tit">第8条 クッキー</h4>
                            <p className="text">AUTOWELLS株式会社はクッキーを使用しません。</p>

                            <h4 className="sub_tit">第9条 個人情報保護責任者</h4>
                            <p className="sm_text">
                                氏名: Geonho Kwak
                                <br />
                                役職: 代表取締役
                                <br />
                                電話: 010-3287-3222 / 062-372-3731
                                <br />
                                メール: andrew.kwak.2025@gmail.com
                                <br />
                                FAX: 062-372-3735
                            </p>

                            <h4 className="sub_tit">第10条 閲覧請求の受付部署</h4>
                            <p className="sm_text">
                                部署: 経営管理室
                                <br />
                                担当者: Geonho Kwak
                                <br />
                                電話: 010-3287-3222 / 062-372-3731
                                <br />
                                メール: andrew.kwak.2025@gmail.com
                                <br />
                                FAX: 062-372-3735
                            </p>

                            <h4 className="sub_tit">第11条 権利侵害に対する救済</h4>
                            <p className="sm_text">
                                - 個人情報紛争調停委員会: 1833-6972 (www.kopico.go.kr)
                                <br />
                                - KISA 個人情報侵害通報センター: 118 (privacy.kisa.or.kr)
                                <br />
                                - 大検察庁: 1301 (www.spo.go.kr)
                                <br />- 警察庁: 182 (ecrm.cyber.go.kr)
                            </p>

                            <h4 className="sub_tit">第12条 プライバシーポリシーの変更</h4>
                            <p className="text">本ポリシーは2022年11月15日から適用されます。 法令、方針またはセキュリティ技術の変更に応じて修正がある場合は、会社ウェブサイトで通知します。</p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("同意する")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "ru" && (
                <div className="input-area">
                    <div className="step_area">Политика конфиденциальности</div>
                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("Руководство по политике конфиденциальности")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                Компания AUTOWELLS соблюдает Закон о защите персональных данных и другие применимые законы, обрабатывает персональные данные законным образом и безопасно управляет ими для защиты прав и свобод субъектов данных. В соответствии со статьей 30 Закона о защите персональных
                                данных данная Политика конфиденциальности устанавливается и публикуется для информирования субъектов данных о процедурах и стандартах обработки персональных данных, а также для обеспечения своевременного и эффективного рассмотрения жалоб.
                            </p>

                            <h4 className="sub_tit">Статья 1. Цели обработки персональных данных</h4>
                            <p className="text">AUTOWELLS обрабатывает персональные данные для следующих целей. Данные не будут использоваться для других целей, и при изменении целей будут предприняты необходимые меры, включая получение отдельного согласия, в соответствии со статьей 18 Закона.</p>
                            <p className="text">
                                1. Биометрическая информация
                                <br />
                                Биометрическая информация (частота сердечных сокращений, частота дыхания, данные о присутствии) используется для исследований системы обнаружения аномалий.
                            </p>

                            <h4 className="sub_tit">Статья 2. Сроки обработки и хранения</h4>
                            <p className="text">
                                ① AUTOWELLS обрабатывает и хранит персональные данные в течение периода, установленного законом, или в течение срока, согласованного субъектом данных при сборе.
                                <br />② Сроки обработки и хранения указаны ниже:
                            </p>
                            <p className="sm_text">
                                1. Регистрация и управление учетной записью: до удаления учетной записи. Если проводится расследование из-за нарушения закона — до его завершения.
                                <br />
                                <br />
                                2. Предоставление товаров или услуг: до завершения поставки и расчетов. Если законом установлены иные сроки хранения, они применяются.
                                <br />
                                - Записи о рекламе: 6 месяцев
                                <br />
                                - Записи о договорах, отменах, оплате, поставках: 5 лет
                                <br />
                                - Записи о жалобах и спорах: 3 года
                                <br />
                                <br />
                                3. Биометрическая информация: до удаления учетной записи. Если проводится расследование из-за нарушения закона — до его завершения.
                            </p>

                            <h4 className="sub_tit">Статья 3. Обрабатываемые категории персональных данных</h4>
                            <p className="text">AUTOWELLS обрабатывает следующие категории данных:</p>
                            <p className="text">
                                1. Регистрация и управление членством — имя, дата рождения, адрес, телефон, email
                                <br />
                                2. Предоставление товаров и услуг — имя, дата рождения, адрес, телефон, email
                                <br />
                                3. Биометрическая информация — частота сердечных сокращений, частота дыхания, данные о присутствии
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <thead>
                                        <tr>
                                            <th>Категория</th>
                                            <th>Цель сбора</th>
                                            <th>Собираемые данные</th>
                                            <th>Срок хранения</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Регистрация</td>
                                            <td>Подтверждение намерения, идентификация, поддержание членства, предотвращение злоупотреблений, согласие родителей для детей до 14 лет, уведомления, обработка жалоб</td>
                                            <td>Имя, дата рождения, адрес, телефон, email</td>
                                            <td>До удаления учетной записи ※ При расследовании — до завершения</td>
                                        </tr>
                                        <tr>
                                            <td>Товары/услуги</td>
                                            <td>Доставка, предоставление услуг, верификация личности и возраста</td>
                                            <td>Имя, дата рождения, адрес, телефон, email</td>
                                            <td>До завершения поставки и расчетов ※ При требовании закона — до окончания срока</td>
                                        </tr>
                                        <tr>
                                            <td>Биометрическая информация</td>
                                            <td>Исследование системы обнаружения аномалий</td>
                                            <td>Частота сердечных сокращений, частота дыхания, данные о присутствии</td>
                                            <td>До удаления учетной записи ※ При расследовании — до завершения</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">Статья 4. Передача третьим лицам</h4>
                            <p className="text">AUTOWELLS предоставляет персональные данные третьим лицам только с согласия субъекта или в случаях, предусмотренных законом.</p>

                            <h4 className="sub_tit">Статья 5. Уничтожение данных</h4>
                            <p className="text">Данные уничтожаются без промедления, когда срок хранения истек, цель обработки достигнута или данные стали ненужными. Электронные файлы удаляются навсегда, бумажные документы уничтожаются шредером или сжигаются.</p>

                            <h4 className="sub_tit">Статья 6. Права субъектов данных</h4>
                            <p className="text">Субъекты данных могут в любое время требовать доступ, исправление, удаление или приостановку обработки своих данных. Для детей младше 14 лет это делают законные представители.</p>

                            <h4 className="sub_tit">Статья 7. Меры безопасности</h4>
                            <p className="text">
                                - Административные меры: внутренние планы, обучение сотрудников
                                <br />- Технические меры: контроль доступа, шифрование, программы безопасности
                                <br />- Физические меры: контроль доступа к серверным и хранилищам данных
                            </p>

                            <h4 className="sub_tit">Статья 8. Cookie</h4>
                            <p className="text">AUTOWELLS не использует cookie.</p>

                            <h4 className="sub_tit">Статья 9. Ответственный за защиту данных</h4>
                            <p className="sm_text">
                                Имя: Geonho Kwak
                                <br />
                                Должность: Генеральный директор
                                <br />
                                Телефон: 010-3287-3222 / 062-372-3731
                                <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Факс: 062-372-3735
                            </p>

                            <h4 className="sub_tit">Статья 10. Отдел по запросам</h4>
                            <p className="sm_text">
                                Отдел: Исполнительный офис
                                <br />
                                Контакт: Geonho Kwak
                                <br />
                                Телефон: 010-3287-3222 / 062-372-3731
                                <br />
                                Email: andrew.kwak.2025@gmail.com
                                <br />
                                Факс: 062-372-3735
                            </p>

                            <h4 className="sub_tit">Статья 11. Средства правовой защиты</h4>
                            <p className="sm_text">
                                - Комитет по урегулированию споров о персональных данных: 1833-6972 (www.kopico.go.kr)
                                <br />
                                - Центр уведомлений о нарушениях персональных данных KISA: 118 (privacy.kisa.or.kr)
                                <br />
                                - Генеральная прокуратура: 1301 (www.spo.go.kr)
                                <br />- Национальная полиция: 182 (ecrm.cyber.go.kr)
                            </p>

                            <h4 className="sub_tit">Статья 12. Изменения политики</h4>
                            <p className="text">Данная политика вступает в силу с 15 ноября 2022 года. В случае изменений законодательства, политики или технологий безопасности компания уведомит об этом на своем веб-сайте.</p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("Согласен")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {lng == "mn" && (
                <div className="input-area">
                    <div className="step_area">Нууцлалын бодлого</div>

                    <div className="title_area">
                        <h1 className="num_title"></h1>
                        <h2 className="title">{t("개인정보 처리방침 안내")}</h2>
                    </div>

                    <div className="input_section" style={{ background: "#fff", padding: 0 }}>
                        <div className="policy_contents_wrap">
                            <p className="text">
                                “Автоуэлс” ХХК нь мэдээлэл эзэмшигчийн эрх, эрх чөлөөг хамгаалахын үүднээс “Хувийн мэдээлэл хамгаалах тухай хууль” болон холбогдох хууль тогтоомжид нийцүүлэн хувийн мэдээллийг хууль ёсоор боловсруулж, аюулгүйгээр хамгаалан удирдаж байна. Иймд “Хувийн мэдээлэл
                                хамгаалах тухай хууль”-ийн 30-р зүйлд заасны дагуу мэдээлэл эзэмшигчид хувийн мэдээлэл боловсруулах журам, стандартын талаар мэдээлж, үүнтэй холбоотой санал гомдлыг хурдан бөгөөд саадгүй шийдвэрлэх зорилгоор энэхүү хувийн мэдээлэл боловсруулах бодлогыг боловсруулан
                                нийтэлж байна.
                            </p>

                            <h4 className="sub_tit">1-р зүйл. Хувийн мэдээлэл боловсруулах зорилго</h4>
                            <p className="text">
                                “Автоуэлс” ХХК нь дараах зорилгоор хувийн мэдээллийг боловсруулна. Боловсруулж буй хувийн мэдээллийг доорх зорилгоос өөрөөр ашиглахгүй бөгөөд ашиглах зорилго өөрчлөгдөх тохиолдолд “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 18-р зүйлд заасны дагуу тусгайлан зөвшөөрөл
                                авах зэрэг шаардлагатай арга хэмжээг авна.
                            </p>

                            <p className="text">
                                1. Биометрийн мэдээлэл
                                <br />
                                Хувь хүний биометрийн мэдээлэл (зүрхний цохилт, амьсгалын тоо, оршин байгаа эсэхийн мэдрэгчийн утга)-ийг хэвийн бус байдлыг ялган илрүүлэх системийн судалгааны зорилгоор боловсруулна.
                            </p>

                            <h4 className="sub_tit">2-р зүйл. Хувийн мэдээлэл боловсруулах ба хадгалах хугацаа</h4>
                            <p className="text">
                                ① “Автоуэлс” ХХК нь хууль тогтоомжид заасан хувийн мэдээлэл хадгалах·ашиглах хугацаа, эсхүл мэдээлэл эзэмшигчээс хувийн мэдээлэл цуглуулах үед зөвшөөрөл авсан хадгалах·ашиглах хугацааны хүрээнд хувийн мэдээллийг боловсруулж, хадгална.
                                <br />② Хувийн мэдээлэл тус бүрийн боловсруулах ба хадгалах хугацаа нь дараах байдалтай байна.
                            </p>

                            <p className="sm_text">
                                1. Вэбсайтын гишүүнчлэл бүртгэл ба удирдлага: Гишүүнчлэл цуцлагдах хүртэл. Гэхдээ доорх нөхцөлд тухайн нөхцөл дуусах хүртэл хадгална.
                                <br />
                                1) Холбогдох хууль тогтоомж зөрчсөнтэй холбоотой мөрдөн шалгах/шалгалт явагдаж байгаа бол тухайн мөрдөн шалгах/шалгалт дуусах хүртэл
                                <br />
                                <br />
                                2. Бараа эсхүл үйлчилгээ үзүүлэх: Бараа·үйлчилгээ нийлүүлэлт дуусч, төлбөр тооцоо·суутгал бүрэн хийгдэх хүртэл. Гэхдээ доорх нөхцөлд тухайн хугацаа дуусах хүртэл хадгална.
                                <br />
                                1) “Цахим худалдаанд хэрэглэгчийн эрхийг хамгаалах тухай хууль”-д заасан тэмдэглэгээ·зар сурталчилгаа, гэрээний агуулга ба биелэлт зэрэг гүйлгээтэй холбоотой бүртгэл
                                <br />
                                - Тэмдэглэгээ·зар сурталчилгааны бүртгэл: 6 сар
                                <br />
                                - Гэрээ эсхүл захиалга цуцлалт, төлбөр, бараа нийлүүлэлтийн бүртгэл: 5 жил
                                <br />
                                - Хэрэглэгчийн гомдол эсхүл маргаан шийдвэрлэлттэй холбоотой бүртгэл: 3 жил
                                <br />
                                <br />
                                2) “Харилцаа холбооны нууцын тухай хууль”-д заасан харилцааны баталгаажуулах өгөгдөл хадгалалт
                                <br />
                                - Захиалагчийн цахилгаан холбооны огноо, эхлэх·дуусах цаг, харилцагчийн дугаар, ашиглалтын тоо, дуудагч суурь станцын байршлын мэдээлэл: 1 жил
                                <br />
                                - Компьютерийн харилцаа холбоо, интернет лог бүртгэл, хандалтын байршлын мөрдөх мэдээлэл: 3 сар
                                <br />
                                <br />
                                3) “Биометрийн таних онцлог мэдээлэл” нь эмзэг мэдээлэлд хамаарах бөгөөд “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 23-р зүйл (эмзэг мэдээлэл боловсруулах)-ийн хүрээнд боловсруулна
                                <br />
                                <br />
                                3. Биометрийн мэдээлэл: Гишүүнчлэл цуцлагдах хүртэл
                                <br />
                                1) Холбогдох хууль тогтоомж зөрчсөнтэй холбоотой мөрдөн шалгах/шалгалт явагдаж байгаа бол тухайн мөрдөн шалгах/шалгалт дуусах хүртэл
                            </p>

                            <h4 className="sub_tit">3-р зүйл. Боловсруулж буй хувийн мэдээллийн төрөл</h4>
                            <p className="text">“Автоуэлс” ХХК нь дараах хувийн мэдээллийг боловсруулж байна.</p>

                            <p className="text">
                                1. Гишүүнчлэл бүртгэл ба удирдлага - Нэр, төрсөн огноо, хаяг, утасны дугаар, имэйл хаяг
                                <br />
                                2. Бараа эсхүл үйлчилгээ үзүүлэх - Нэр, төрсөн огноо, хаяг, утасны дугаар, имэйл хаяг
                                <br />
                                3. Биометрийн мэдээлэл - Хувь хүний биометрийн мэдээлэл (зүрхний цохилт, амьсгалын тоо, оршин илрүүлэх утга)
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="20%" />
                                        <col width="20%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Ангилал</th>
                                            <th>Цуглуулах зорилго</th>
                                            <th>Цуглуулах мэдээлэл</th>
                                            <th>Хадгалах ба ашиглах хугацаа</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Гишүүнчлэл бүртгэл ба удирдлага</td>
                                            <td>
                                                Гишүүнээр бүртгүүлэх хүсэл баталгаажуулах, гишүүнчлэлтэй үйлчилгээ үзүүлэхтэй холбоотой өөрийг нь таних·баталгаажуулах, гишүүний эрхийн хүчинтэй байдлыг хадгалах·удирдах, үйлчилгээний буруугаар ашиглалтаас сэргийлэх, 14 нас хүрээгүй хүүхдийн хувийн
                                                мэдээлэл боловсруулах үед хууль ёсны төлөөлөгчийн зөвшөөрөл байгаа эсэхийг шалгах, төрөл бүрийн мэдэгдэл·мэдээлэл хүргэх, санал гомдол шийдвэрлэх зорилго
                                            </td>
                                            <td>Нэр, төрсөн огноо, хаяг, утасны дугаар, имэйл хаяг</td>
                                            <td>
                                                Гишүүнчлэл цуцлагдах хүртэл <br />※ Гэхдээ хууль зөрчсөнтэй холбоотой мөрдөн шалгах, шалгалт үргэлжилж байвал тухайн мөрдөн шалгах, шалгалт дуусах хүртэл
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                Бараа эсхүл <br />
                                                үйлчилгээ үзүүлэх
                                            </td>
                                            <td>Бараа хүргэлт, үйлчилгээ үзүүлэх, контент нийлүүлэх, тохируулгатай үйлчилгээ үзүүлэх, өөрийг нь баталгаажуулах, нас баталгаажуулах зорилгоор хувийн мэдээллийг боловсруулна.</td>
                                            <td>Нэр, төрсөн огноо, хаяг, утасны дугаар, имэйл хаяг</td>
                                            <td>
                                                Бараа·үйлчилгээ нийлүүлэлт дуусч, төлбөр тооцоо·суутгал бүрэн хийгдэх хүртэл <br />※ Гэхдээ хууль тогтоомжийн дагуу устгалгүйгээр хадгалах шаардлагатай тохиолдолд тухайн хугацаа хүртэл
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Биометрийн мэдээлэл</td>
                                            <td>Хэвийн бус байдлыг ялган илрүүлэх системийн судалгаа</td>
                                            <td>Зүрхний цохилт, амьсгалын тоо, оршин илрүүлэх утга</td>
                                            <td>
                                                Гишүүнчлэл цуцлагдах хүртэл <br />※ Гэхдээ хууль зөрчсөнтэй холбоотой мөрдөн шалгах, шалгалт үргэлжилж байвал тухайн мөрдөн шалгах, шалгалт дуусах хүртэл
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">4-р зүйл. Хувийн мэдээллийг гуравдагч этгээдэд өгөх тухай</h4>
                            <p className="text">
                                ① “Автоуэлс” ХХК нь мэдээлэл эзэмшигчийн хувийн мэдээллийг энэ бодлогод заасан боловсруулалтын зорилгын хүрээнд л боловсруулна. Мөн мэдээлэл эзэмшигчийн зөвшөөрөл, хуулийн тусгай заалт зэрэг “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 17, 18-р зүйлд хамаарах
                                тохиолдолд л гуравдагч этгээдэд олгох бөгөөд үүнээс бусад тохиолдолд гуравдагч этгээдэд өгөхгүй.
                                <br />② Үйлчилгээг саадгүй үзүүлэхийн тулд дараах тохиолдолд мэдээлэл эзэмшигчийн зөвшөөрлийг авч, зайлшгүй шаардлагатай хамгийн бага хэмжээнд л олгоно.
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                        <col width="40%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Ангилал</th>
                                            <th>Цуглуулах зорилго</th>
                                            <th>Цуглуулах мэдээлэл</th>
                                            <th>Хадгалах ба ашиглах хугацаа</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Төрийн байгууллага</td>
                                            <td>Тодорхой мэдээлэл олгох</td>
                                            <td>Нэр, төрсөн огноо, хаяг, утасны дугаар, имэйл хаяг, биометрийн мэдээлэл</td>
                                            <td>
                                                Гишүүнчлэл цуцлагдах хүртэл <br />※ Гэхдээ хууль зөрчсөнтэй холбоотой мөрдөн шалгах, шалгалт үргэлжилж байвал тухайн мөрдөн шалгах, шалгалт дуусах хүртэл
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p className="text">
                                ③ “Автоуэлс” ХХК нь гамшиг, халдварт өвчин, амь нас·бие махбодод яаралтай аюул учруулах осол, хэрэг, эд хөрөнгийн яаралтай хохирол зэрэг онцгой байдал үүссэн тохиолдолд мэдээлэл эзэмшигчийн зөвшөөрөлгүйгээр холбогдох байгууллагад хувийн мэдээллийг олгож болно.
                            </p>

                            <div className="table_box">
                                <table className="tbl_policy">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Ангилал</th>
                                            <th>Хуулийн үндэслэл</th>
                                            <th>Олгох байгууллага</th>
                                            <th>Олгогдох хувийн мэдээлэл</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Амиа хорлох эрсдэлтэй хүнийг хамгаалах</td>
                                            <td>Амиа хорлолоос урьдчилан сэргийлэх тухай хууль</td>
                                            <td>
                                                Цагдаагийн байгууллага <br />
                                                Онцгой байдлын (гал түймэр) байгууллага
                                            </td>
                                            <td>• (Мэдээлэл-харилцааны үйлчилгээ үзүүлэгч бол) яаралтай аврах ажиллагааны зорилтот хүний нэр, иргэний бүртгэлийн дугаар (байхгүй бол төрсөн огноо), хаяг, утасны дугаар, ID, имэйл хаяг, мөн хувийн байршлын мэдээлэл</td>
                                        </tr>

                                        <tr>
                                            <td>Яаралтай аврах хүсэлт зэрэгт хариу арга хэмжээ авах</td>
                                            <td>Байршлын мэдээллийн тухай хууль</td>
                                            <td>Онцгой байдлын (гал түймэр) байгууллага</td>
                                            <td>• Хувийн байршлын мэдээлэл</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 className="sub_tit">5-р зүйл. Хувийн мэдээлэл устгах журам ба арга</h4>
                            <p className="text">
                                ① “Автоуэлс” ХХК нь хадгалах хугацаа дуусах, боловсруулах зорилго биелэх зэрэг шалтгаанаар хувийн мэдээлэл шаардлагагүй болсон тохиолдолд сааталгүйгээр тухайн хувийн мэдээллийг устгана.
                                <br />
                                ② Мэдээлэл эзэмшигчийн зөвшөөрлөөр тогтоосон хадгалах хугацаа дууссан эсвэл зорилго биелсэн ч өөр хууль тогтоомжийн дагуу үргэлжлүүлэн хадгалах шаардлагатай бол тухайн мэдээллийг тусдаа өгөгдлийн сан(DB) руу шилжүүлэх эсвэл хадгалах байрлалыг өөрчилж тусгаарлан
                                хадгална.
                                <br />③ Устгах журам ба арга нь дараах байдалтай байна.
                            </p>

                            <p className="text">
                                1. Устгах журам
                                <br />
                                “Автоуэлс” ХХК нь устгах шалтгаан үүссэн хувийн мэдээллийг сонгон, “хувийн мэдээлэл боловсруулагчийн нэр”-ийн хувийн мэдээлэл хамгаалах хариуцагчийн зөвшөөрлөөр устгана.
                                <br />
                                <br />
                                2. Устгах арга
                                <br />
                                Цахим файлаар хадгалсан хувийн мэдээллийг сэргээх боломжгүй байдлаар устгана. Цаасан баримт дээрх хувийн мэдээллийг бутлагч машинаар буталж эсвэл шатааж устгана.
                            </p>

                            <p className="sub_tit">6-р зүйл. Мэдээлэл эзэмшигч болон хууль ёсны төлөөлөгчийн эрх·үүрэг, хэрэгжүүлэх арга</p>
                            <p className="text">
                                ① Мэдээлэл эзэмшигч нь “Автоуэлс” ХХК-аас өөрийн хувийн мэдээллийг үзэх, засварлах, устгах, боловсруулахыг зогсоохыг шаардах зэрэг эрхээ хүссэн үедээ хэрэгжүүлж болно.
                                <br />
                                ※ 14 нас хүрээгүй хүүхдийн хувийн мэдээлэлтэй холбоотой үзлэг зэрэг хүсэлтийг хууль ёсны төлөөлөгч шууд гаргана. 14 ба түүнээс дээш насны насанд хүрээгүй мэдээлэл эзэмшигч нь өөрийн эрхээ өөрөө хэрэгжүүлэх эсвэл хууль ёсны төлөөлөгчөөрөө дамжуулан хэрэгжүүлж болно.
                                <br />
                                ② Эрхээ хэрэгжүүлэх хүсэлтийг “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн хэрэгжилтийн журмын 41-р зүйлийн 1-д заасны дагуу бичгээр, цахим шуудангаар, факсаар гэх мэтээр илгээж болох бөгөөд “Автоуэлс” ХХК нь сааталгүй арга хэмжээ авна.
                                <br />
                                ③ Мөн хууль ёсны төлөөлөгч, эсвэл итгэмжлэгдсэн төлөөлөгчөөр дамжуулан хэрэгжүүлж болно. Энэ тохиолдолд “Хувийн мэдээлэл боловсруулах аргачлалын тухай мэдэгдэл(2020-7)”-ийн хавсралт №11 маягтын дагуу итгэмжлэл ирүүлэх шаардлагатай.
                                <br />
                                ④ Хувийн мэдээлэл үзэх болон боловсруулахыг зогсоох хүсэлт нь “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 35-р зүйлийн 4, 37-р зүйлийн 2-т заасны дагуу хязгаарлагдаж болзошгүй.
                                <br />
                                ⑤ Өөр хууль тогтоомжид тухайн хувийн мэдээлэл цуглуулах объект гэж тодорхой заасан тохиолдолд устгахыг шаардах боломжгүй.
                                <br />⑥ “Автоуэлс” ХХК нь үзэх, засварлах·устгах, боловсруулахыг зогсоох хүсэлт гаргасан этгээд нь өөрөө эсвэл хууль ёсны төлөөлөгч мөн эсэхийг шалгана.
                            </p>

                            <h4 className="sub_tit">7-р зүйл. Хувийн мэдээллийн аюулгүй байдлыг хангах арга хэмжээ</h4>
                            <p className="text">
                                1. Удирдлагын арга хэмжээ: Дотоод удирдлагын төлөвлөгөө боловсруулах·хэрэгжүүлэх, хариуцсан баг ажиллуулах, ажилтны тогтмол сургалт
                                <br />
                                2. Техникийн арга хэмжээ: Хувийн мэдээлэл боловсруулах системийн хандалтын эрхийн удирдлага, хандалтын хяналтын систем суурилуулах, хувийн мэдээллийг шифрлэх, хамгаалалтын програм суурилуулах ба шинэчлэх
                                <br />
                                3. Физик арга хэмжээ: Серверийн өрөө, архивын өрөө зэрэгт нэвтрэх хяналт
                            </p>

                            <h4 className="sub_tit">8-р зүйл. Автоматаар цуглуулах төхөөрөмжийн суурилуулалт·ажиллагаа болон татгалзах тухай – шаардлагатай тохиолдолд</h4>
                            <p className="text">&lt;Хувийн мэдээлэл боловсруулагчийн нэр&gt; нь мэдээлэл эзэмшигчийн ашиглалтын мэдээллийг хадгалж, үе үе дуудаж ашигладаг “cookie” ашигладаггүй.</p>

                            <h4 className="sub_tit">9-р зүйл. Хувийн мэдээлэл хамгаалах хариуцагчийн тухай</h4>
                            <p className="text">
                                ① “Автоуэлс” ХХК нь хувийн мэдээлэл боловсруулах ажлыг нийтэд нь хариуцан удирдах бөгөөд хувийн мэдээлэлтэй холбоотой гомдол шийдвэрлэлт, хохирол нөхөн төлбөр зэрэг асуудлыг зохицуулахын тулд доорх хувийн мэдээлэл хамгаалах хариуцагчийг томилсон байна.
                            </p>

                            <p className="sm_text">
                                ‣ Хувийн мэдээлэл хамгаалах хариуцагч <br />
                                Нэр: Гвак Гонхо
                                <br />
                                Албан тушаал: Гүйцэтгэх захирал
                                <br />
                                Холбоо барих: 010-3287-3222
                                <br />
                                Утас: 062-372-3731
                                <br />
                                Имэйл: andrew.kwak.2025@gmail.com
                                <br />
                                Факс: 062-372-3735
                                <br />※ Хувийн мэдээлэл хамгаалах хариуцсан нэгж рүү холбогдоно.
                            </p>

                            <h4 className="sub_tit">10-р зүйл. Хувийн мэдээлэл үзэх хүсэлтийг хүлээн авах·шийдвэрлэх нэгж</h4>
                            <p className="text">
                                Мэдээлэл эзэмшигч нь “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 35-р зүйлд заасан хувийн мэдээлэл үзэх хүсэлтийг доорх нэгжид гаргаж болно.
                                <br />
                                “Автоуэлс” ХХК нь хувийн мэдээлэл үзэх хүсэлтийг хурдан шуурхай шийдвэрлэхийг хичээнэ.
                            </p>

                            <p className="sm_text">
                                ‣ Хувийн мэдээлэл үзэх хүсэлт хүлээн авах·шийдвэрлэх нэгж <br />
                                Нэгжийн нэр: Удирдлагын өрөө <br />
                                Хариуцагч: Гвак Гонхо <br />
                                Холбоо барих: 010-3287-3222, Оффисын утас: 062-372-3731 <br />
                                Имэйл: andrew.kwak.2025@gmail.com <br />
                                Факс: 062-372-3735
                            </p>

                            <h4 className="sub_tit">11-р зүйл. Мэдээлэл эзэмшигчийн эрх ашиг зөрчигдсөн тохиолдолд авах арга хэмжээ</h4>
                            <p className="text">
                                ① Мэдээлэл эзэмшигч нь хувийн мэдээлэл зөрчигдсөнтэй холбоотойгоор тусламж авахын тулд Хувийн мэдээллийн маргаан зохицуулах хороо, Солонгосын Интернет ба Аюулгүй байдлын агентлагийн (KISA) Хувийн мэдээлэл зөрчлийн мэдээлэх төв зэрэг байгууллагад маргаан шийдвэрлүүлэх
                                эсвэл зөвлөгөө авах хүсэлт гаргаж болно. Мөн бусад хувийн мэдээлэл зөрчлийн мэдүүлэг, зөвлөгөөний хувьд доорх байгууллагад хандана уу.
                            </p>

                            <p className="sm_text">
                                1. Хувийн мэдээллийн маргаан зохицуулах хороо: (кодгүй) 1833-6972 (www.kopico.go.kr)
                                <br />
                                2. Хувийн мэдээлэл зөрчлийн мэдээлэх төв: (кодгүй) 118 (privacy.kisa.or.kr)
                                <br />
                                3. Ерөнхий прокурорын газар: (кодгүй) 1301 (www.spo.go.kr)
                                <br />
                                4. Цагдаагийн ерөнхий газар: (кодгүй) 182 (ecrm.cyber.go.kr)
                            </p>

                            <p className="text">
                                ② “Автоуэлс” ХХК нь мэдээлэл эзэмшигчийн хувийн мэдээллээ өөрөө шийдэх эрхийг баталгаажуулж, хувийн мэдээлэл зөрчлийн зөвлөгөө болон хохирол нөхөн олговорын талаар дэмжлэг үзүүлэхийг хичээж байна. Мэдүүлэг эсвэл зөвлөгөө шаардлагатай тохиолдолд доорх нэгжтэй холбоо
                                барина уу.
                            </p>

                            <p className="sm_text">
                                ‣ Хувийн мэдээлэл хамгаалалттай холбоотой хэрэглэгчийн зөвлөгөө ба мэдүүлэг <br />
                                Нэгжийн нэр: Удирдлагын өрөө
                                <br />
                                Хариуцагч: Гвак Гонхо
                                <br />
                                Холбоо барих: 010-3287-3222, Оффисын утас: 062-372-3731 <br />
                                Имэйл: andrew.kwak.2025@gmail.com
                                <br />
                                Факс: 062-372-3735
                            </p>

                            <p className="text">
                                ③ “Хувийн мэдээлэл хамгаалах тухай хууль”-ийн 35-р зүйл (үзэх), 36-р зүйл (засварлах·устгах), 37-р зүйл (боловсруулалтыг зогсоох) зэрэгт заасан хүсэлтийг төрийн байгууллагын дарга татгалзсан эсвэл шийдвэрлэхгүй байснаас үүдэн эрх, ашиг сонирхол зөрчигдсөн этгээд нь
                                Захиргааны давж заалдах хуулийн дагуу захиргааны давж заалдах хүсэлт гаргаж болно.{" "}
                            </p>

                            <p className="sm_text"> ‣ Төв захиргааны давж заалдах хороо: (кодгүй) 110 (www.simpan.go.kr)</p>

                            <h4 className="sub_tit">12-р зүйл. Хувийн мэдээлэл боловсруулах бодлогын өөрчлөлт</h4>
                            <p className="text">
                                ① Энэхүү хувийн мэдээлэл боловсруулах бодлого нь 2022. 11. 15-ны өдрөөс хэрэгжинэ.
                                <br />② Цаашид хууль тогтоомж·бодлого эсхүл хамгаалалтын технологи өөрчлөгдөхтэй холбоотойгоор нэмэлт·устгал·засвар хийх шаардлага гарвал компанийн вэбсайтаар дамжуулан өөрчлөлтийн шалтгаан, агуулгыг мэдэгдэнэ.
                            </p>
                        </div>

                        <div className="start-btn-area">
                            <button className="Next" onClick={() => clickNext()}>
                                {t("동의하기")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </main>
    );
};

export default Agree;
